import { createAction } from '@ngrx/store';

export const sidebarToggle = createAction('[Sidebar] Toggle');